The details of the position opening to have its status updated.
